!(function (e) {
    var t = {};
    function n(o) {
        if (t[o]) return t[o].exports;
        var r = (t[o] = { i: o, l: !1, exports: {} });
        return e[o].call(r.exports, r, r.exports, n), (r.l = !0), r.exports;
    }
    (n.m = e),
        (n.c = t),
        (n.d = function (e, t, o) {
            n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: o });
        }),
        (n.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (n.t = function (e, t) {
            if ((1 & t && (e = n(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var o = Object.create(null);
            if ((n.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                for (var r in e)
                    n.d(
                        o,
                        r,
                        function (t) {
                            return e[t];
                        }.bind(null, r)
                    );
            return o;
        }),
        (n.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return n.d(t, "a", t), t;
        }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (n.p = ""),
        n((n.s = 62));
})({
    23: function (e, t, n) {},
    4: function (e, t, n) {},
    6: function (e, t, n) {},
    62: function (e, t, n) {
        "use strict";
        n.r(t), n(4), n(23), n(6), n(8), n(9);
        var o = location.pathname;
        function r() {
            const e = [...new FormData(document.forms.collectionFilters).entries()]
                .filter((e) => "tag" === e[0].split("__")[1])
                .filter((e) => "" !== e[1])
                .map((e) => e[1]);
            o = `${document.forms.collectionFilters.baseUrl.value}/${e.join("+")}`;
        }
        function c(e) {
            e.preventDefault(), (window.location = o);
        }
        function i(e) {
            e.preventDefault();
            const t = e.target.closest("form");
            t.reset(), t.classList.toggle("active");
            
            if(document.querySelector('.filter-dropdown__wrapper').classList.contains('active')){
                document.querySelector('.collection-filters').classList.remove('semi-active');
                document.querySelector('.filter-dropdown__wrapper').classList.add("semi-active");
                document.querySelector('.filter-dropdown__wrapper').classList.remove('active');
                document.querySelector('.collection-filters').classList.remove('semi-active');
                document.querySelector('.collection-filters .sort_selector').classList.remove('active');
                document.querySelector('.collection-filters .sort_selector').classList.add('semi-active');
            }else{
                document.querySelector('.filter-dropdown__wrapper').classList.toggle("semi-active");
            }

            if(t.classList.contains('active')){
                document.querySelector('#shopify-section-collection-three-across').classList.add('open');
                if(document.querySelectorAll('.current-filters').length > 0){
                    document.querySelector('.current-filters').classList.add('opend');
                }
            }else{
                document.querySelector('#shopify-section-collection-three-across').classList.remove('open');
                if(document.querySelectorAll('.current-filters').length > 0){
                    document.querySelector('.current-filters').classList.remove('opend');
                }
            }

        }
      
        document.addEventListener("DOMContentLoaded", () => {
            const e = location.search;
            if (e.includes("sort_by")) {
                const t = document.querySelector("#" + e.slice(9)),
                    n = t.dataset.sortName;
                (document.querySelector(".sort-by__value").innerHTML = n), (t.checked = !0);
            } else document.forms.collectionSortBy.querySelector("input").checked = !0;
        });
        document.addEventListener("DOMContentLoaded", function () {
            document.forms.collectionFilters.addEventListener("change", r),
                document.forms.collectionFilters.addEventListener("submit", c),
                document.forms.collectionFilters.filterBy.addEventListener("click", i),
                document.forms.collectionSortBy.sortBy.addEventListener("click", i);
        });
    },
    8: function (e, t, n) {},
    9: function (e, t) {
        document.addEventListener("DOMContentLoaded", (e) => {
            document.querySelector("button.category").addEventListener("click", (e) => {
                document.querySelector("button.category").classList.toggle("expanded"),
                    document.querySelector(".parent-link-wrapper").classList.toggle("expanded"),
                    document.querySelector(".mobile.nav-container").classList.remove("mobile-nav--open");
            }),
                document.querySelector("ul.sticky").addEventListener("click", (e) => {
                    document.querySelector("button.category").classList.toggle("expanded"), document.querySelector(".parent-link-wrapper").classList.toggle("expanded");
                });
        });
    },
});
